import TextModal from './TextModal/TextModal'
import ContentModal from './ContentModal/ContentModal'
import DialogModal from './DialogModal/DialogModal'
import ReportModal from './ReportModal/ReportModal'
import EditableModal from './EditableModal/EditableModal'
import DialogWithFormModal from './DialogWithFormModal/DialogWithFormModal'
import DialogWithFormTableModal from './DialogWithFormTableModal/DialogWithFormTableModal'

import AddCatalogModal from './AddCatalogModal/AddCatalogModal'

// voting
import VoteModal from './VoteModal/VoteModal'

// hero
import HeroAddModal from './HeroAddModal/HeroAddModal'
import HeroViewModal from './HeroViewModal/HeroViewModal'


export default {
  TextModal,
  ContentModal,
  DialogModal,
  ReportModal,
  EditableModal,
  DialogWithFormModal,
  DialogWithFormTableModal,

  AddCatalogModal,

  // voting
  VoteModal,

  // hero
  HeroAddModal,
  HeroViewModal,
}
